import { SET_ADJUSTMENTS } from '../types/adjustments'

const initState = {
  adjustments: {},
  lastModified: null,
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_ADJUSTMENTS:
      return { ...state, adjustments: action.payload, lastModified: new Date().getTime() }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/adjustments.js